import { serviceMaker } from "..";
import { IPagination } from "../../data/AppInterface";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";
import { paginationParams, toQueryString } from "../../utils/QueryString";

export interface IBusinessInformationPayload {
  company_name: string;
  gstin: string;
  address_line1: string;
  address_line2: string | null;
  city: string;
  state_id: string;
  country_id: string;
  zip_code: string;
  pan: string | null;
  email: string | null;
  phone: string | null;
  sac_code: string | null;
  invoice_footer_note: string | null;
  receipt_footer_note: string | null;
}

export const GET_BUSINESS_INFORMATION = () =>
  serviceMaker(
    API_ENDPOINTS.get_business_information.url,
    API_ENDPOINTS.get_business_information.method
  );

export const SAVE_BUSINESS_INFORMATION = (payload: IBusinessInformationPayload) =>
  serviceMaker(
    API_ENDPOINTS.save_business_information.url,
    API_ENDPOINTS.save_business_information.method,
    payload
  );

export const GET_BUSINESS_INFORMATION_VERSIONS = (pagination: IPagination) =>
  serviceMaker(
    API_ENDPOINTS.get_business_information_versions.url +
      toQueryString(paginationParams(pagination)),
    API_ENDPOINTS.get_business_information_versions.method
  );
